/**
 * Shared namespace for this library.
 */
export const namespace = 'Marketing Discovery Utils';
/**
 * Mutates a tracker instance. Used within library components, utils, etc.
 * which accept the app's tracker instance.
 *
 * @example
 * ```tsx
 * const MyLibraryComponent = ({ appTrackerInstance, onClick }) => {
 * const handleOnClick = (event: ClickEvent) => {
 *   onClick(event);
 *   mutateTrackerInstance(appTrackerInstance).track('Marketing Discovery Utils', 'Element Clicked', { ... });
 * }
 * return <button onClick={}>click me</button>;
};
 * ```
 *
 * @see https://product.hubteam.com/docs/usage-tracking-manual/docs/frontend/library-tracking.html#example-2
 * @see https://hubspot.slack.com/archives/CA6LJJMHB/p1745576349947739?thread_ts=1745571721.498299&cid=CA6LJJMHB
 */
export const mutateTrackerInstance = trackerInstance => {
  const clonedTrackerInstance = trackerInstance.clone({
    standalone: true,
    trackerName: 'marketing-discovery-utils'
  });
  return clonedTrackerInstance;
};

/**
 * Non-mutated tracker instance helper type, used in library components.
 */

/**
 * Mutated tracker instance with static properties specific to
 * `marketing-discovery-utils` library to enforce consistency downstream.
 */

/**
 *  @internal
 * Events that require little to no engagement from the user. They are highly
 * passive events.
 *
 * @example modal load or page view
 */

/**
 * @internal
 * Events that require engagement from the user but do NOT cause a change to
 * the portal, such as storing new data.
 *
 * @example creating a type of template
 */

/**
 * @internal
 * Name of the event defined in Usage Tracker UI.
 */

/**
 *
 * Required properties for marketing discovery utils events.
 * @see https://docs.google.com/document/d/12aN5hGrBjuDkodoI2sIEf7V6z1rxXNppW5thmu44gC4/edit
 */